// extracted by mini-css-extract-plugin
export default {"cls1":"TagElement-cls1___6368031a57b386e0712","cls2":"TagElement-cls2___c15fec9da0398988cbd TagElement-cls1___6368031a57b386e0712"};